import isCsairApp from '../app/isCsairApp';
import appLogin from '../app/appLogin';
/**
 * 统一登录，适用于h5和csair app
 * @param {string} h5URL 登录地址
 * @param {function} error 报错回调
 */
export function uniteLogin(h5URL, error) {
    if (isCsairApp()) {
        appLogin(error);
    }
    else {
        window.location.href = h5URL;
    }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/login/index.js
// module id = null
// module chunks = 